<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter BookTitlePage"><div class="title-block-book">
<h6 style="margin-bottom: -0.4em;"> </h6>
<h1 style="margin-bottom: -0.4em;"><img alt="" height="225" src="title_iii.jpg" width="300"/></h1>
</div> <div class="imprint"><p><img alt="alt" src="logo.png"/></p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a9781847677099_booktitlepage.vue?ca531e88